<template>
    <PopoverTrigger v-bind="props">
        <slot />
    </PopoverTrigger>
</template>

<script setup lang="ts">
import type { DsPopoverTriggerProps } from '@/components/design-system/popover/ds-popover.types';
import { PopoverTrigger } from 'reka-ui';

const props = withDefaults(defineProps<DsPopoverTriggerProps>(), {
    asChild: true,
});
</script>
